import { createAction } from "@logicsoftware/redux-toolkit";
import { put, takeEvery } from "redux-saga/effects";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { setPersonalization } from "~/Redux/Personalization/reducers";
import { callApi } from "../Sagas/effects/callApi";
import { watchUpdateRequests } from "../Sagas/effects/watchUpdateRequests";
import { withCallback } from "../Sagas/redux-saga-callback";
import {
    loadPersonalization,
    PersonalizationActionTypes,
    savePersonalization,
    SavePersonalizationArgs,
} from "./actions";

const loadPersonalizationHandler = withCallback(function* (action: ReturnType<typeof loadPersonalization>) {
    const result = yield callApi(({ ajaxOptions }) =>
        OAuthClient.postJson(appUrls.personalization.load, { key: action.key }, ajaxOptions)
    );

    yield put(setPersonalization({ [action.key]: result }));

    return result;
});

const watchPersonalizationLoading = () => takeEvery(PersonalizationActionTypes.LOAD, loadPersonalizationHandler);

function* savePersonalizationHandler({ payload: { data, key } }: ReturnType<typeof saveOnServer>) {
    yield callApi(({ ajaxOptions }) =>
        OAuthClient.postJson(
            appUrls.personalization.save,
            {
                key,
                json: JSON.stringify(data),
            },
            ajaxOptions
        )
    );
}

const saveOnServer = createAction<SavePersonalizationArgs>("personalization/saveOnServer");
const watchPersonalizationSaving = () =>
    watchUpdateRequests({
        pattern: saveOnServer,
        groupKey: (action: ReturnType<typeof saveOnServer>) => action.payload.key,
        worker: savePersonalizationHandler,
    });

export function* personalizationRootSaga() {
    yield watchPersonalizationSaving();
    yield watchPersonalizationLoading();

    yield takeEvery(PersonalizationActionTypes.SAVE, function* ({ data, key }: ReturnType<typeof savePersonalization>) {
        yield put(setPersonalization({ [key]: data }));
        yield put(saveOnServer({ data, key }));
    });
}
